import { FileType } from '@office-start/document-types';
import { Referral } from '@office-start/telemetry-types';
export function getOtelReferralFromFileType(fileType) {
    switch (fileType) {
        case FileType.Audio:
            return Referral.Audio;
        case FileType.Clipchamp:
            return Referral.Clipchamp;
        case FileType.Designer:
            return Referral.Designer;
        case FileType.Excel:
            return Referral.ExcelOnline;
        case FileType.Fluid:
        case FileType.MeetingNotes:
            return Referral.Loop;
        case FileType.Forms:
        case FileType.FormsQuiz:
            return Referral.OfficeForms;
        case FileType.List:
            return Referral.Lists;
        case FileType.MeetingObject:
            return Referral.MeetingObject;
        case FileType.MindMeister:
            return Referral.ThirdPartyApp;
        case FileType.Monday:
            return Referral.ThirdPartyApp;
        case FileType.MyAnalytics:
            return Referral.MyAnalytics;
        case FileType.NewsArticle:
            return Referral.NewsArticle;
        case FileType.OneNote:
        case FileType.OneNoteClassNoteBook:
        case FileType.OneNotePage:
            return Referral.OneNoteOnline;
        case FileType.Outlook:
            return Referral.Mail;
        case FileType.Pdf:
            return Referral.PDF;
        case FileType.Photos:
            return Referral.Photos;
        case FileType.Platform:
            return Referral.Platform;
        case FileType.PlayLists:
            return Referral.PlayLists;
        case FileType.Project:
        case FileType.ProjectOperations:
        case FileType.Portfolio:
            return Referral.Project;
        case FileType.PowerBI:
            return Referral.PowerBI;
        case FileType.PowerPoint:
            return Referral.PowerPointOnline;
        case FileType.StreamsVideo:
        case FileType.Stream:
        case FileType.ScreenRecording:
            return Referral.MicrosoftStream;
        case FileType.Sway:
            return Referral.Sway;
        case FileType.Text:
            return Referral.Text;
        case FileType.ThirdParty:
            return Referral.ThirdPartyApp;
        case FileType.Trello:
            return Referral.ThirdPartyApp;
        case FileType.UpcomingMeeting:
            return Referral.Calendar;
        case FileType.Video:
            return Referral.Video;
        case FileType.Visio:
            return Referral.VisioOnline;
        case FileType.Whiteboard:
            return Referral.Whiteboard;
        case FileType.Word:
            return Referral.WordOnline;
        default:
            return Referral.UnknownApp;
    }
}
//# sourceMappingURL=getOtelReferralFromFileType.js.map